import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PageHeader from "../components/ui/PageHeader";
import CalendarView from "../components/calendar/CalendarView";
import EventForm from "../components/calendar/EventForm";
import EventDetail from "../components/calendar/EventDetail";
import { Box, Button, Dialog, DialogContent, useTheme } from "@mui/material";
import { Add } from "@mui/icons-material";
import { useSearchParams } from "react-router-dom";

const CalendarPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const [showForm, setShowForm] = useState(false);
  const [editingEvent, setEditingEvent] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    if (searchParams.get("new") === "true") {
      setShowForm(true);
    }
  }, []);

  const handleEdit = (event) => {
    setEditingEvent(event);
    setShowForm(true);
  };

  const handleSelectEvent = (event) => {
    setSelectedEvent(event);
  };

  const handleSave = () => {
    setShowForm(false);
    setEditingEvent(null);
    setRefreshKey((k) => k + 1);
  };

  const handleCloseDetail = () => {
    setSelectedEvent(null);
  };

  return (
    <Box>
      <PageHeader
        title="Calendario"
        action={
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => {
              setEditingEvent(null);
              setShowForm(true);
            }}
            sx={{
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
              boxShadow: 'none',
              '&:hover': {
                boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
                filter: 'brightness(1.05)',
              },
            }}
          >
            Nuevo Evento
          </Button>
        }
      />

      <CalendarView
        key={refreshKey}
        onEdit={handleEdit}
        onSelectEvent={handleSelectEvent}
      />

      {/* Diálogo del formulario */}
      <Dialog
        key={editingEvent?.id || "new"}
        open={showForm}
        onClose={() => {
          setShowForm(false);
          setEditingEvent(null);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
            maxHeight: "90vh",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <EventForm
            event={editingEvent}
            onSave={handleSave}
            onCancel={() => {
              setShowForm(false);
              setEditingEvent(null);
            }}
          />
        </DialogContent>
      </Dialog>

      {/* Diálogo de detalle */}
      <Dialog
        open={!!selectedEvent}
        onClose={handleCloseDetail}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <EventDetail
            event={selectedEvent}
            onEdit={handleEdit}
            onClose={handleCloseDetail}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default CalendarPage;